export default class IntersectionObservable {
  #intersectionObserver;
  #listeners = /* @__PURE__ */ new Map();
  constructor(options) {
    this.#intersectionObserver = new window.IntersectionObserver(
      (entries) => this.next(entries),
      options
    );
  }
  next(entries) {
    entries.forEach(({ target, isIntersecting }) => {
      if (this.#listeners.has(target)) {
        this.#listeners.get(target)(isIntersecting);
      }
    });
  }
  register(el, callback) {
    this.#listeners.set(el, callback);
    this.#intersectionObserver.observe(el);
  }
  unregister(el) {
    this.#listeners.delete(el);
    this.#intersectionObserver.unobserve(el);
  }
}
export const getIntersectionObservable = (options) => {
  const { node, key } = getNodeAndKey(options);
  if (!node.observables.has(key)) {
    node.observables.set(key, new IntersectionObservable(options));
  }
  const observable = node.observables.get(key);
  return {
    register: (el, callback) => observable.register(el, callback),
    unregister: (el) => observable.unregister(el)
  };
};
const getNodeAndKey = ({ root, ...options }) => {
  const node = root || window.document.documentElement;
  if (!node.observables) {
    node.observables = /* @__PURE__ */ new Map();
  }
  return { key: JSON.stringify({ ...options }), node };
};
